import { useLocation } from "react-router-dom";
import CallbackEmails from "../purchases/tables/CallbackEmails";

const Callback = () => {
  const location = useLocation();
  const getQueryParams = () => {
    const queryParams = new URLSearchParams(location.search);

    return {
      code: queryParams.get("code"),
    };
  };

  const { code } = getQueryParams();

  return <div>{code && <CallbackEmails code={code} />}</div>;
};

export default Callback;
